import './error-ribbon.scss';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { defineComponent } from 'vue';

export const ErrorRibbon = defineComponent({
    mixins: [reactiveVueMixin],
    template: require('./error-ribbon.html'),
    data() {
        return {
            show: true,
            subject$: new Subject(),
        }
    },
    created() {
        this.subscribe();
    },
    mounted() {
        this.subject$.next();
    },
    methods: {
        subscribe() {
            this.subscribeTo(this.subject$.pipe(debounceTime(2e3)), () => {
                this.show = false;
            });
        },
    },
})
